import React, { useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ThemeContext } from '../theme';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { theme, toggleTheme } = useContext(ThemeContext);

  const handleToggle = () => setMenuOpen((open) => !open);
  const handleClose = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-brand">
          <NavLink to="/" className="nav-logo" onClick={handleClose}>
            SignCrypt
          </NavLink>
        </div>
        <button className={`hamburger${menuOpen ? ' open' : ''}`} onClick={handleToggle} aria-label="Toggle navigation">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={`nav-menu${menuOpen ? ' show' : ''}`}>
          <NavLink to="/" className="nav-item" end onClick={handleClose}>
            <span className="nav-text">Home</span>
          </NavLink>
          <NavLink to="/encrypt" className="nav-item" onClick={handleClose}>
            
            <span className="nav-text">Encrypt</span>
          </NavLink>
          <NavLink to="/decrypt" className="nav-item" onClick={handleClose}>
            <span className="nav-text">Decrypt</span>
          </NavLink>
          <NavLink to="/about" className="nav-item" onClick={handleClose}>
            <span className="nav-text">About</span>
          </NavLink>
          <NavLink to="/learn" className="nav-item" onClick={handleClose}>
            <span className="nav-text">Learn</span>
          </NavLink>
          <NavLink to="/signal-hub" className="nav-item" onClick={handleClose}>
            <span className="nav-icon">📡</span>
            <span className="nav-text">Signal Hub</span>
          </NavLink>
          <button className="theme-toggle-btn" onClick={toggleTheme} title="Toggle dark/light mode">
            {theme === 'dark' ? '🌙' : '☀️'}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 